import { useRentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import accessUtils from '../utils/accessUtils';
import { FEED_OVERRIDES_TAG } from '../constants/FeedOverrideConstants';

import type { FeedOverrideSection } from '@zg-rentals/ts-rental-manager-api-client';

export const useFeedOverrideSectionEnabled = (listingAlias: string, section: FeedOverrideSection): boolean => {
  const { data } = useRentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections(
    { listingAlias },
    {
      enabled: Boolean(listingAlias) && accessUtils.canAccessFeedOverrides(),
      meta: {
        tags: [FEED_OVERRIDES_TAG],
        context: { api: 'rental-manager-api', details: 'useFeedOverrideSectionEnabled' },
      },
    },
  );

  return data?.sections.find((sectionState) => sectionState.section === section)?.enabled ?? false;
};
